import { useEffect, useState } from 'react'
import { ACTION_TYPES, EmptyGuid } from '@components/utils/constants'
import { BTN_SEARCH } from '@components/utils/textVariables'
import { useGoogleAnalyticsEvent } from 'hooks/useGAEvent'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { getCurrentPage } from '@framework/utils/app-util'
import { useUI } from '@components/ui'

const FILTER_KEYS = {
  BRAND: 'brandNoAnlz',
  CATEGORY: 'classification.category',
  PRICE: 'price.raw.withTax',
  RATING: 'rating',
  CLOTHING_TYPE: 'attributes.value~clothing.type',
  COLOR: 'attributes.value~global.colour',
  DRESS_STYLE: 'attributes.value~dress.style',
  GENDER: 'attributes.value~global.gender',
  OCCASION: 'attributes.value~occasion.type',
  SIZE: 'attributes.value~clothing.size',
}

const FilterItem = ({
  option,
  optionIdx,
  sectionKey,
  sectionName,
  isChecked = false,
  isCheckboxTickDisabled = false,
  bgColor = () => false,
  onSelect,
  onSort,
  removeClassHtml = () => {},
  closeSidebar = () => {},
  routerFilters,
  count,
  routerSort,
  ...props
}: any) => {
  const [isCheckboxChecked, setCheckbox] = useState(isChecked)
  const [selectedSortOption, setSelectedSortOption] = useState('')
  const trackGoogleAnalyticsEvent = useGoogleAnalyticsEvent()
  const { user } = useUI()

  useEffect(() => {
    setCheckbox(isChecked)
  }, [isChecked])

  useEffect(() => {
    if (!(routerFilters.length > 0)) setCheckbox(false)
  }, [routerFilters])

  const handleCheckbox = () => {
    setCheckbox(!isCheckboxChecked)
    if (!isCheckboxChecked) {
      trackGoogleAnalyticsEvent(
        GA_EVENT.FILTER_CLICK,
        {
          current_page: getCurrentPage(),
          header: sectionName,
          filter_value: option.name,
          loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
        },
        window
      )
    }
    let obj = {
      Key: sectionKey ? sectionKey : option.key,
      Value: option.name,
      IsSelected: true,
      name: sectionName,
    }
    let type = !isCheckboxChecked
      ? ACTION_TYPES.ADD_FILTERS
      : ACTION_TYPES.REMOVE_FILTERS
    onSelect(obj, type)
    closeSidebar()
    removeClassHtml()
  }
  const handleRadioBtns = () => {
    let obj = {
      Key: sectionKey ? sectionKey : option.key,
      Value: option.name,
      IsSelected: true,
      name: sectionName,
    }
    if (option['item'] == 'Sort') {
      // @ts-ignore
      obj['item'] = option['item']
    }
    let type = ''
    if (routerSort === selectedSortOption && selectedSortOption != '') {
      type = ACTION_TYPES.REMOVE_FILTERS
      setSelectedSortOption('')
    } else {
      type = ACTION_TYPES.ADD_FILTERS
      setSelectedSortOption(option.key)
    }
    onSort(obj.Key, type)
    closeSidebar()
    removeClassHtml()
  }

  const generateOptionName = () => {
    if (sectionKey === FILTER_KEYS.PRICE)
      return `₹${option.from} ${
        option.top == null ? 'and above' : ' - ₹' + option.to
      }` //TBD
    if (sectionKey === FILTER_KEYS.COLOR) return option.name.split('|')[1]
    if (sectionKey === FILTER_KEYS.RATING)
      return `${parseFloat(option.name).toFixed(1)} ★`
    if (sectionKey === FILTER_KEYS.RATING)
      return `${parseFloat(option.name).toFixed(1)} ★`
    else return option.name
  }

  let checkboxBgColor = bgColor(option) || '#F3F4F5'
  let borderColor = '#cccccc'
  let bgClass = 'bg-nonselected-facet'
  if (isCheckboxChecked && !isCheckboxTickDisabled) {
    checkboxBgColor = '#EC5E28'
    borderColor = '#EC5E28'
    bgClass = 'bg-selected-facet'
  }
  if (option.item == 'Sort' && routerSort === option.key) {
    checkboxBgColor = '#EC5E28'
    borderColor = '#EC5E28'
    bgClass = 'bg-selected-facet'
  }

  return (
    <div key={option.value} className={bgClass}>
      <div className="grid items-center w-full grid-cols-1 xs-pb-2">
        {option?.item == 'Sort' ? (
          <input
            name={`Sorting`}
            defaultValue={option.value}
            type="radio"
            className="w-4 h-4 border-gray-300 rounded filter-input"
          />
        ) : (
          <input
            name={`${optionIdx}-input[]`}
            defaultValue={option.value}
            type="checkbox"
            className="w-4 h-4 border-gray-300 rounded filter-input"
          />
        )}

        {option.item == 'Sort' ? (
          <label
            htmlFor={`Sorting`}
            onClick={() => {
              handleRadioBtns()
            }}
            className="relative ml-0 text-sm text-black cursor-pointer filter-label"
          >
            {routerSort == option.key && (
              <div
                style={{
                  content: '',
                  float: 'right',
                  right: '12px',
                  top: '5px',
                  zIndex: 99999,
                  position: 'absolute',
                  width: '6px',
                  height: '10px',
                  border: 'solid #fff',
                  borderWidth: '0 2px 2px 0',
                  transform: 'rotate(45deg)',
                }}
              />
            )}
            <span className="inline-block sm:w-3/4 f-label-name">
              <span className="mob-trun-label">{generateOptionName()}</span>
              <span className="relative top-0 px-1 text-xs font-normal text-gray-400">
                {sectionKey === FILTER_KEYS.COLOR && (
                  <span className="pr-2 text-black">{option.name} </span>
                )}
                {count}
              </span>
            </span>
            {option.item == 'Sort' && (
              <div
                style={{
                  content: '',
                  top: '2px',
                  float: 'right',
                  height: '18px',
                  width: '18px',
                  borderRadius: '24px',
                  background: checkboxBgColor,
                  border: '1px solid #cccccc',
                  position: 'relative',
                  marginRight: '6px',
                }}
              />
            )}
          </label>
        ) : (
          <label
            htmlFor={`${optionIdx}-input[]`}
            onClick={() => {
              if (option.item == 'Sort') {
                handleRadioBtns()
              } else {
                handleCheckbox()
              }
            }}
            className="relative ml-0 text-sm text-black cursor-pointer filter-label"
          >
            {isCheckboxChecked && !isCheckboxTickDisabled && (
              <div
                style={{
                  content: '',
                  float: 'right',
                  right: '12px',
                  top: '5px',
                  zIndex: 99999,
                  position: 'absolute',
                  width: '6px',
                  height: '10px',
                  border: 'solid #fff',
                  borderWidth: '0 2px 2px 0',
                  transform: 'rotate(45deg)',
                }}
              />
            )}
            <span className="inline-block sm:w-3/4 f-label-name">
              <span className="mob-trun-label">{generateOptionName()}</span>
              <span className="relative top-0 px-1 text-xs font-normal text-gray-400">
                {sectionKey === FILTER_KEYS.COLOR && (
                  <span className="pr-2 text-black">{option.name} </span>
                )}
                {count}
              </span>
            </span>
            {sectionName == 'Colours' && (
              <div
                title={option.name}
                style={{
                  top: '2px',
                  float: 'left',
                  height: '18px',
                  width: '18px',
                  borderRadius: '10px',
                  background: option.name,
                  border: '1px solid ' + option.name,
                  position: 'relative',
                  marginRight: '6px',
                  right: '0',
                }}
              />
            )}
            {sectionKey === FILTER_KEYS.COLOR && (
              <>
                <div
                  style={{
                    content: '',
                    top: '2px',
                    float: 'right',
                    height: '18px',
                    width: '18px',
                    borderRadius: '2px',
                    background: checkboxBgColor,
                    border: '1px solid #cccccc',
                    position: 'relative',
                    marginRight: '6px',
                  }}
                />
              </>
            )}
            {sectionKey != FILTER_KEYS.COLOR && (
              <div
                style={{
                  content: '',
                  top: '2px',
                  float: 'right',
                  height: '18px',
                  width: '18px',
                  borderRadius: '2px',
                  background: checkboxBgColor,
                  border: '1px solid #cccccc',
                  position: 'relative',
                  marginRight: '6px',
                }}
              />
            )}
          </label>
        )}
      </div>
    </div>
  )
}

const SearchInput = ({ placeholder, handleSearch }: any) => {
  return (
    <>
      <label className="sr-only">{BTN_SEARCH}</label>
      <input
        type="text"
        onChange={(e) => handleSearch(e.target.value)}
        autoComplete={BTN_SEARCH}
        placeholder={BTN_SEARCH}
        className="w-full min-w-0 px-4 py-1 text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
      />
    </>
  )
}

const getCustomComponent = (type: string) => {
  switch (type) {
    case FILTER_KEYS.BRAND:
      // return (props: any) => <SearchInput {...props} />
      return () => null
    case FILTER_KEYS.CATEGORY:
      return () => null
    case FILTER_KEYS.SIZE:
      return () => null
    case FILTER_KEYS.OCCASION:
      return () => null
    default:
      return () => null
  }
}

export default function FilterList({
  items = [],
  sectionKey,
  handleFilters,
  handleSort,
  routerFilters,
  closeSidebar,
  removeClassHtml,
  sectionName,
  routerSort,
}: any) {
  const [filterItems, setFilterItems] = useState(items)

  useEffect(() => {
    setFilterItems(items)
  }, [items])

  const handleSearch = (value: string) => {
    const itemsClone = [...items]
    const filteredItems = itemsClone.filter((item: any) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    )
    setFilterItems(filteredItems)
  }

  const PROPS_LIST = {
    [FILTER_KEYS.BRAND]: {
      handleSearch: (value: string) => handleSearch(value),
    },
    [FILTER_KEYS.CATEGORY]: {
      handleSearch: (value: string) => handleSearch(value),
    },
    [FILTER_KEYS.SIZE]: {
      handleSearch: (value: string) => handleSearch(value),
    },
    [FILTER_KEYS.OCCASION]: {
      handleSearch: (value: string) => handleSearch(value),
    },
    [FILTER_KEYS.COLOR]: {
      isCheckboxTickDisabled: true,
      bgColor: (item: any) => item.name.split('|')[0],
    },
  }

  const isDefaultChecked = (sectionKey: string, value: string) => {
    return !!routerFilters.find(
      (filter: any) => filter.Key === sectionKey && filter.Value === value
    )
  }

  return (
    <>
      {getCustomComponent(sectionKey)(/*{ ...PROPS_LIST[sectionKey] }*/)}
      <div className="space-y-2 h-full max-panel mob-max-panel">
        {filterItems.map((option: any, optionIdx: number) => {
          const isChecked = isDefaultChecked(sectionKey, option.name)
          return (
            <FilterItem
              sectionKey={sectionKey}
              sectionName={sectionName}
              option={option}
              count={option?.count}
              onSelect={handleFilters}
              onSort={handleSort}
              routerSort={routerSort}
              optionIdx={optionIdx}
              key={optionIdx}
              isChecked={isChecked}
              closeSidebar={closeSidebar}
              removeClassHtml={removeClassHtml}
              routerFilters={routerFilters}
              {...PROPS_LIST[sectionKey]}
            />
          )
        })}
      </div>
    </>
  )
}
